import { AccountDto } from "../../state/account"

export const isAccountEligibleForDynamicTaxFeature = (account: AccountDto) => {
    return ["USD"].includes(account.attributes.currency)
}


// WEBPACK FOOTER //
// ./src/utils/account/utils.ts